import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { forgotPassword } from "../../actions/authAction";
import {
  analyticsPostAction,
  becomePractitioner,
  profilePostAction,
} from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { getUserDetail, setUsetDetailToLocalStorage } from "../../utils/helper";
import history from "../../utils/history";
import { states } from "../../constants/states";
import FileUploadComponent from "../../components/FileUploadComponent";
import TextError from "../../components/WraapperComponent/TextError";
const RolePopup = ({ closePopup, id, agency, description }) => {
  const dispatch = useDispatch();
  const initialValues = {
    license_id: id,
    license_agency: agency != "NT" && agency != "OT" ? "STATE" : agency,
    license_description: description,
    license_state: agency,
    file: null,
  };

  const validationSchema = Yup.object({
    license_id: Yup.string()
      .nullable()
      .matches(
        /^[a-zA-Z0-9_.-]*$/,
        "Only letters and numbers, 2 to 20 characters"
      )
      .min(2, "Only letters and numbers, 2 to 20 characters")
      .max(20, "Only letters and numbers, 2 to 20 characters")
      .required("This field is required"),
    license_agency: Yup.string().nullable().required("This field is required"),
    license_state: Yup.string()
      .when("license_agency", {
        is: (value) => value === "STATE",
        then: Yup.string().required("This field is required"),
        otherwise: Yup.string(),
      })
      .nullable(),
    license_description: Yup.string()
      .when("license_agency", {
        is: (value) => value === "OT",
        then: Yup.string().nullable().required("This field is required"),
        otherwise: Yup.string(),
      })
      .nullable(),
    file: Yup.mixed()
      .required("Document is required")
      .test(
        "fileSize",
        "File size must be less than 5MB",
        (value) => value && value.size <= 5 * 1024 * 1024
      )
      .test(
        "fileType",
        "Invalid file type. Please upload an image or a pdf",
        (value) =>
          value &&
          (value.type.startsWith("image/") || value.type == "application/pdf")
      ),
  });

  const onSubmit = (values, { resetForm }) => {
    let formData = new FormData();
    formData.append("license_id", values.license_id);
    formData.append(
      "license_agency",
      values.license_agency === "STATE"
        ? values.license_state
        : values.license_agency
    );
    formData.append(
      "license_description",
      values.license_agency === "OT" ? values.license_description : ""
    );
    formData.append("file", values.file);
    formData.append("client_id", getUserDetail()?.id);
    formData.append("token", getUserDetail()?.token);
    formData.append("action", "changeUserRole");
    formData.append("role_id", 4);
    formData.append("update", 0);

    dispatch(
      becomePractitioner(formData, (success) => {
        if (success) {
          var user = getUserDetail();
          let index = user.role.indexOf(4);
          user.role[index] = 1;
          user.user = {
            first_name: user.firstName,
            last_name: user.lastName,
          };

          setUsetDetailToLocalStorage(user);
          window.location.reload();
        }
      })
    );
  };
  const agencies = [
    { key: "NCCAOM-National", value: "NT" },
    { key: "State", value: "STATE" },
    { key: "Other", value: "OT" },
  ];
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">
            {id ? "Edit License" : "Become Practitioner"}
          </h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              errors,
              touched,
              values,
              handleBlur,
              setFieldValue,
              setFieldTouched,
            }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        handleBlur={handleBlur}
                        label="* Enter License Number"
                        name="license_id"
                        hasError={errors.license_id && touched.license_id}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="dropdown"
                        label="* SELECT ISSUING BODY*"
                        name="license_agency"
                        handleBlur={handleBlur}
                        hasError={
                          errors.license_agency && touched.license_agency
                        }
                        options={agencies}
                      />
                    </div>
                    {values.license_agency === "STATE" && (
                      <div className="col-sm-12">
                        <FormikControl
                          control="dropdown"
                          label="* SELECT ISSUING STATE"
                          name="license_state"
                          handleBlur={handleBlur}
                          hasError={
                            errors.locense_state && touched.license_state
                          }
                          options={states}
                        />
                      </div>
                    )}
                    {values.license_agency === "OT" && (
                      <div className="col-sm-12">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Description"
                          name="license_description"
                          handleBlur={handleBlur}
                          hasError={
                            errors.license_description &&
                            touched.license_description
                          }
                        />
                      </div>
                    )}
                  </div>

                  <FileUploadComponent
                    className="mb-1"
                    setFieldTouched={setFieldTouched}
                    setFieldValue={setFieldValue}
                  />
                  <div className="mt-1">
                    <ErrorMessage name="file" component={TextError} />
                  </div>
                  <div className="submit-section mt-2">
                    <button className="btn-orange" type="submit">
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RolePopup;
